/** The one rationale rule, said the same on a desk and on a card: what the check looks for (the coach prompt `rationale_check`, rubric 1), why a text bounced, and the way out. */
import type { ErrorBody } from "@bsim/contracts";

/** What counts as a reason, in the check's own terms. */
export const RATIONALE_RULE = "A reason says why you chose this: name a product, a measure, a goal, a risk or a trade-off.";
export const RATIONALE_EXAMPLE = "For example: “Raise the price: concentration is high and we want fewer new loans.”";

const LEAD: Readonly<Record<string, string>> = {
  filler: "That reads like a placeholder.",
  off_topic: "That does not seem to be about this decision.",
  too_vague: "That is a slogan more than a reason.",
};
const DEFAULT_LEAD = "That does not read as a reason yet.";

/** The refusal's reason code (`details.reason`), when the api sent one. */
export const bounceReason = (error: ErrorBody["error"]): string | undefined => (typeof error.details?.["reason"] === "string" ? error.details["reason"] : undefined);

/** The whole bounce message: why, the rule, an example, and the way out. */
export const bounceLine = (reason?: string): string => `${(reason === undefined ? undefined : LEAD[reason]) ?? DEFAULT_LEAD} ${RATIONALE_RULE} ${RATIONALE_EXAMPLE} Or send it as is.`;
export const BOUNCE_LINE = bounceLine();
